export { default as CopyIcon } from '~icons/lucide/copy';
